/* eslint-disable max-len */

export default {
  lang: 'English',
  homeScreen: {
    title: 'Life-Changing Voyages', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
    messages: 'Messages',
  },
  notification: {
    newAndNow: 'New & Now!',
    alert: 'Alert',
    message: 'Message',
    contest: 'Contest',
    badge: 'New Badge',
    'content-update': 'Content Update',
    events: 'Events',
    other: 'Notification',
  },
  loginScreen: {
    title: 'Travel Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to the',
      headerBottom: 'Quark Expeditions Program', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Certificate of completion',
      1: 'Free, high-quality marketing materials',
      2: 'Access to special offers and promotions.',
      3: 'Qualify to participate in destination FAMS',
      4: 'High Impact Sales Information & Resources',
      5: 'Access to mobile Sales Companion App',
      6: 'Real-time product directory',
      7: 'Sales tips',
    },
    confirmProfile:
      'Please verify your account details and fill in any necessary information.',
    emailPrompt:
      'Please enter your email address and password to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      agency: 'Agency',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Confirm your password',
      firstName: 'First name',
      lastName: 'Last name',
      agencyName: 'Agency Name',
      stateProvince: 'State / Province',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      select: 'Please select an option below',
      country: 'Country / Region',
      opt: "Stay In Touch! Yes, I'd like to opt in to communications from Quark Expeditions that will keep me posted on news, events, incentives, FAM’s and more!",
    },
    noAgent: {
      noAgentButton: "I'm not an agent",
      title: 'Thank you for your interest in the Quark Expeditions program.', // Product specific
      messageWeb:
        'The content on this site is exclusively for travel professionals. \n To learn more about Quark Expeditions, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
    registered: 'This email is already registered',
  },
  welcomeScreen: {
    title: 'Welcome to the\nQuark Expeditions Sales Companion', // Product specific
    helloUser: 'Hello {{name}}',
    hello: 'Hello,',
    fromAgency: 'from {{agency}}',
    notUser: 'Not {{name}}?',
    introOnline:
      "Train immediately online or preload the content so it's always available for offline use!",
    introOffline:
      'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start learning',
    continueTraining: 'Continue learning',
    graduated: 'Congratulations!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    badge: 'View Badge >',
    start: 'Start',
    continue: 'Continue',
    restart: 'Restart',
    review: 'Review',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Complete',
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    courseComplete: 'Continue',
    endReached: "You've reached the end",
    retainEnd:
      'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    watchListenRead: 'Watch, Listen & Read more',
    trouble:
      "It looks like you're having trouble, please re-read the content on the previous page(s) and try again.",
    confirm: 'Confirm your answer',
    choose: 'Please choose an answer',
    skip: 'Return >',
    viewAllTitle: 'Training Tip',
    viewAll:
      'In order to proceed to the next page, please click on the icons to view the supplementary content. Videos, maps and other helpful information have been provided to enhance your training and ensure you achieve PRO status.',
    fillBlanks: 'Fill in the blank(s):',
    next: 'Next question',
    retry: 'Try Again',
    fastTrackText: {
      success:
        "Congratulations, you've passed the Fast Track course and unlocked the rest of the training!",
      failed:
        "Unfortunately you didn't pass the Fast Track course, you can resume your training to earn your diploma!",
    },
    fastTrack: 'Become a Swiss Travel Superstar!',
    fastTrackExplanation:
      'Simply take the quiz on the following pages for your chance to win a FAM to Switzerland!<br><br><span style="font-weight: bold">You will find all answers to the quiz questions in the following ways:</span><br><br>1.	The content that you learned in the Rail Europe and Switzerland modules<br><br>2.	And on the following websites:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Be sure to review these resources in detail before taking the quiz! Only those with the highest of scores will have the chance to be invited to the FAM.</span>',
    fastTrackButton: 'Click Here to Take the Swiss Superstar Quiz',
    grading: 'Your final grade is: {grade}%',
  },
  nav: {
    home: 'Home',
    train: 'Learn',
    learn: 'Learn',
    retain: 'Retain',
    directory: 'Showcases',
    showcases: 'Directory',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    rewards: 'Rewards',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Contact',
    reportCard: 'View Diploma',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
  },
  contentHeaders: {
    train: 'Learn',
    retain: 'Retain',
    subapps: 'Quark Expeditions Partner Modules',
    maintrainings: 'Quark Expeditions Essentials',
    subtrainings: 'Specialization Modules',
  },
  pageDescriptions: {
    train: 'Educate, engage and become the expert.',
    retain:
      'Your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.',
    promote: 'Start the conversation with your clients and prospects.',
    sell: 'Answer client questions and close the sale.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps: '',
    maintrainings: 'The basics for selling Quark Expeditions',
    subtrainings: 'Learn about the specific products',
  },
  general: {
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    previous: 'Previous',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    page: 'Page',
    search: 'Search',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for: {query}',
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {query}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    complete: 'Continue',
    courseComplete: 'Course Complete!',
    chapterComplete: 'Chapter Completed!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message:
      'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource on your favorite social media!',
    download: 'Download',
  },
  sharing: {
    copyURL: 'Copy Link',
    copied: 'Copied',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header:
      "It looks like you're trying to access the {appName} app from a mobile device",
    body: 'To download this program simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Certificate of completion',
      2: 'Free, high-quality marketing materials',
      3: 'Qualify to participate in destination FAMS',
      4: 'High Impact Sales Information & Resources',
      5: 'Access to mobile Sales Companion App',
      6: 'Sales tips',
    },
  },
  custom: {
    splitUsers: 'I Am A ...',
    brandAmbassador: 'Brand Ambassador',
    travelPro: 'Travel Professional',
  },
  search: {
    pages: 'Pages',
    resources: 'Resources',
  },
};
